import { useCallback, useState } from 'react'
import { BorrowerLayout, NonEligibleLayout } from 'ui'

import { Notifications } from '@mantine/notifications'
import { useFetcher, useLocation, useNavigate } from '@remix-run/react'

import { NavigationProvider } from '../../context/NavigationContext'
import ApiErrorToast from '../ApiErrorToast'
import { AppNavigation } from '../AppNavigation'
import { GlobalActionErrorHandler } from '../GlobalActionErrorHandler'
import NetworkStatusChecker from '../NetworkStatusCheck'
import StorageBoundaryModal from '../StorageBoundaryModal'

type LayoutPropsType = {
  pageError?: string
  children: React.ReactNode
  showHeader: boolean
  showUser: boolean
  data: any
}
const PAGES_WITH_NAVIGATION = ['dashboard', 'inactive-applications', 'my-loans', 'continue'] // paths where you want to show AppNavigation

export const Layout = ({ children, showHeader, showUser, data, pageError }: LayoutPropsType) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const fetcher = useFetcher<{ success?: boolean }>()
  const [cookieDisclaimerDismissed, setCookieDisclaimerDismissed] = useState(false)
  const shouldShowNavigation = PAGES_WITH_NAVIGATION.includes(pathname.split('/')[1])

  const showCookieDisclaimer = Boolean(data?.showCookieDisclaimer) && !cookieDisclaimerDismissed

  const handleCookieDisclaimerAccept = useCallback(() => {
    setCookieDisclaimerDismissed(true)
    fetcher.submit({}, { method: 'post', action: '/api/mpower-cookie-consent' })
  }, [fetcher])

  return (
    <NavigationProvider>
      <Notifications zIndex={20000} />
      <ApiErrorToast />
      <GlobalActionErrorHandler />
      <NetworkStatusChecker />
      <StorageBoundaryModal />
      {showHeader ? (
        <BorrowerLayout
          updatedValue={(val: string) => navigate(`/${val}`)}
          firstName={data?.firstName}
          lastName={data?.lastName}
          showUser={showUser}
          pathname={pathname}
          pageError={pageError}
          data={data}
          showCookieDisclaimer={showCookieDisclaimer}
          onCookieDisclaimerAccept={handleCookieDisclaimerAccept}
        >
          {shouldShowNavigation && (
            <AppNavigation lastName={data?.lastName} firstName={data?.firstName} />
          )}
          {children}
        </BorrowerLayout>
      ) : (
        <NonEligibleLayout pathname={pathname} pageError={pageError}>
          {children}
        </NonEligibleLayout>
      )}
    </NavigationProvider>
  )
}

export default Layout
